import { AxiosResponse } from "axios";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { requestWithToken, requestWithoutToken } from "services/api";

export const useGeneralQueryWithToken = <Data = any>(
	url: string,
	params: object = {},
	options: UseQueryOptions<AxiosResponse<Data>, Error> = {}
) =>
	useQuery({
		queryKey: [url, params],
		queryFn: () => requestWithToken.get<Data>(url, { params }).then((response: AxiosResponse) => response),
		...options
	});

export const useGeneralQueryWithoutToken = <Data = any>(
	url: string,
	params: object = {},
	options: UseQueryOptions<AxiosResponse<Data>, Error> = {}
) =>
	useQuery({
		queryKey: [url, params],
		queryFn: () => requestWithoutToken.get<Data>(url, { params }).then((response: AxiosResponse) => response),
		...options
	});
